import { render } from "./ListCdtSpont.vue?vue&type=template&id=563658c5&scoped=true"
import script from "./ListCdtSpont.vue?vue&type=script&lang=js"
export * from "./ListCdtSpont.vue?vue&type=script&lang=js"

import "./ListCdtSpont.vue?vue&type=style&index=0&id=563658c5&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563658c5"]])

export default __exports__